/**
 * Build a youtube.com/embed URL for iframe preview from a normal watch / Shorts / youtu.be link.
 * Returns null if the URL is not a recognizable YouTube video page.
 */
export function youtubeEmbedUrlFromVideoPageUrl(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  try {
    const u = new URL(trimmed);
    const host = u.hostname.replace(/^www\./, '');

    if (host === 'youtu.be') {
      const id = u.pathname.split('/').filter(Boolean)[0];
      if (id && /^[\w-]{6,}$/.test(id)) {
        return `https://www.youtube.com/embed/${encodeURIComponent(id)}?rel=0`;
      }
      return null;
    }

    if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
      const v = u.searchParams.get('v');
      if (v && /^[\w-]{6,}$/.test(v)) {
        return `https://www.youtube.com/embed/${encodeURIComponent(v)}?rel=0`;
      }
      const shorts = u.pathname.match(/^\/shorts\/([\w-]+)/);
      if (shorts?.[1]) {
        return `https://www.youtube.com/embed/${encodeURIComponent(shorts[1])}?rel=0`;
      }
      const embed = u.pathname.match(/^\/embed\/([\w-]+)/);
      if (embed?.[1]) {
        return `https://www.youtube.com/embed/${encodeURIComponent(embed[1])}?rel=0`;
      }
      const live = u.pathname.match(/^\/live\/([\w-]+)/);
      if (live?.[1]) {
        return `https://www.youtube.com/embed/${encodeURIComponent(live[1])}?rel=0`;
      }
    }
  } catch {
    return null;
  }
  return null;
}
